import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth as useAppAuth } from '../contexts/AuthContext';

export function CallbackPage() {
  const { isLoading, isAuthenticated, user, error } = useAppAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated && user) navigate('/dashboard', { replace: true });
  }, [isLoading, isAuthenticated, user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className={error ? 'text-red-700' : 'text-gray-500'}>{error ?? 'Signing you in…'}</div>
    </div>
  );
}
